import { lastValueFrom } from 'rxjs';
import { ApiKeyRepositoryImplementation } from '../infrastructure/api-keys-repository-implementation';
import { CreateApiKeyDTO } from '../domain/api-keys/entity';

const apiKeyRepository = new ApiKeyRepositoryImplementation();

/**
 * List all API Keys for the current user.
 */
export async function listApiKeys(uid: string, cid: string | null) {
    return await lastValueFrom(apiKeyRepository.list(uid, cid));
}

/**
 * Create a new API Key.
 */
export async function createApiKey(uid: string, cid: string | null, data: CreateApiKeyDTO) {
    return await lastValueFrom(apiKeyRepository.create(uid, cid, data));
}

/**
 * Delete an API Key.
 */
export async function deleteApiKey(uid: string, cid: string | null, id: number) {
    return await lastValueFrom(apiKeyRepository.delete(uid, cid, id));
}
